import styled from "@emotion/styled"
import { Button, css, FormControl, InputLabel, Select } from "@mui/material"
import { sharedColors } from "ui/theme/colors"

export const InputsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    grid-template-columns: 1fr 1fr 1fr;
    gap: 32px;
  }
`

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    gap: 32px;
    padding-top: 24px;
  }
`

export const StyledFormControl = styled(FormControl)`
  width: 100%;
  ${({ theme }) => theme.breakpoints.up("md")} {
    width: 352px;
    margin-top: -8px;
  }
`

export const StyledInputLabel = styled(InputLabel)`
  &[data-shrink="true"] {
    transform: translate(14px, 0px) scale(0.75);
  }
`

export const StyledInputLabelNumber = styled(InputLabel)`
  &[data-shrink="true"] {
    transform: translate(14px, -2px) scale(0.75);
  }
`

export const CheckboxRow = styled.div<{ isMultiLine?: boolean }>`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: flex-start;
  grid-column: 1 / -1;
  ${({ isMultiLine }) =>
    isMultiLine &&
    css`
      label {
        align-items: flex-start;
        .MuiCheckbox-root {
          padding-top: 0;
        }
      }
    `}
`

export const StyledDivider = styled.div`
  display: none;
  ${({ theme }) => theme.breakpoints.up("md")} {
    display: block;
    width: 1px;
    height: 24px;
    background-color: ${sharedColors.borderGray};
  }
`

export const StyledHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  ${({ theme }) => theme.breakpoints.up("md")} {
    align-items: center;
    flex-direction: row;
    gap: 16px;
  }
`

export const StyledButton = styled(Button)`
  width: 100%;
  ${({ theme }) => theme.breakpoints.up("md")} {
    width: 300px;
  }
`

export const StyledSelect = styled(Select)`
  height: 56px !important;
  & .MuiSelect-select {
    display: flex;
    align-items: flex-end;
  }
  & .MuiOutlinedInput-input {
    padding: 12px !important;
  }
`

export const StyledSelectMenuProps = {
  anchorOrigin: {
    vertical: "bottom" as const,
    horizontal: "left" as const,
  },
  transformOrigin: {
    vertical: "top" as const,
    horizontal: "left" as const,
  },
  MenuListProps: {
    autoFocusItem: false,
  },
  PaperProps: {
    style: {
      marginTop: "1px",
      borderRadius: "0 0 12px 12px",
    },
    sx: {
      height: "300px",
      overflowY: "scroll",
      outline: `1px solid ${sharedColors.labelGray}`,
      "::-webkit-scrollbar": {
        WebkitAppearance: "none",
        width: "20px",
      },
      "::-webkit-scrollbar-thumb": {
        borderRadius: "200px",
        backgroundColor: "#D1D5DB",
        border: "8px solid transparent",
        backgroundClip: "content-box",
      },
      "::-webkit-scrollbar-track": {
        backgroundColor: "transparent",
      },
      "& .MuiMenuItem-root": {
        padding: "16px",
      },
    },
  },
}
